import React from 'react';
import './InstructionsModal.scss';

const InstructionsModalForAssessor = ({ isOpen, onClose, onContinue, Button }) => {
  if (!isOpen) return null;

  return (
    <div className="instructions-modal">
      <div className="instructions-content">
        <h2>Instructions for Assessors</h2>
        <p>
          As an assessor, please follow the steps below to review and validate user submissions effectively
        </p>

        <h3>Review Assessment Responses Thoroughly</h3>
        <ul>
          <li>Go through all the responses provided by the user carefully, ensuring accuracy and completeness.</li>
          <li>In the left pane you can view the questions of the module and status for each of the questions.</li>
          <li>The questions that are <b>Pending</b>, need to be assessed by yourself. Remaining questions will be <b>Not Required for Evaluation or User might not have answered it.</b></li>
          <li>For each of the question you have the option to add Observation, Assessment References, Insights and Recommendations</li>
          <li>You can add multiple Assessment References and Recommendations</li>
          <li>Finally score the question in the scale of <b>1 to 5.</b></li>
          <li>Use the <b>Preview Screen</b> to review all your entries before submission.</li>
        </ul>

        <h3>Final Submission</h3>
        <ul>
          <li>Ensure all sections are complete and accurate before clicking <b>Final Submit.</b></li>
          <li>Once submitted, your evaluation will be considered final and cannot be edited.</li>
        </ul>

        <div className="instructions-buttons">
          <Button
            title="Back"
            onClick={onClose}
            buttonStyle={{ height: '44px' }}
            titleStyle={{ fontSize: '20px', fontWeight: '600' }}
          />
          <Button
            title="Continue"
            onClick={onContinue}
            buttonStyle={{ height: '44px' }}
            titleStyle={{ fontSize: '20px', fontWeight: '600' }}
          />
        </div>
      </div>
    </div>
  );
};

export default InstructionsModalForAssessor;
